import { alpha, inputClasses, styled } from "@mui/material"
import { DataGridPremium, gridClasses } from "@mui/x-data-grid-premium"

export const DEFAULT_PAGE_OPTIONS = [10, 20, 30, 50, 100]

export const StyledTable = styled(DataGridPremium)(({ theme: { palette }, theme }) => ({
	border: "unset",
	zIndex: 1,
	borderRadius: 0,
	[` & .${gridClasses.main}:not(:first-of-type)`]: {
		borderTop: `1px solid ${palette.grey[300]}`,
	},
	"& input": {
		fontSize: theme.typography.fontSize,
	},
	"@keyframes loading": {
		"0%": { backgroundColor: alpha(palette.grey[500], 0.1) },
		"100%": { backgroundColor: alpha(palette.grey[500], 0.1) },
	},
	"& .context-menu-active:hover": {
		background: palette.grey[100],
	},
	"& .context-menu-active": {
		pointerEvents: "none",
		background: palette.blue[50],
		opacity: 0.8,
	},
	[`& .${gridClasses.columnHeader}.${gridClasses["columnHeader--sorted"]}`]: {
		backgroundColor: `${palette.yellow[200]} !important`,
	},
	[`& .${gridClasses.columnHeader}.${gridClasses["columnHeader--pinnedRight"]}:not(.${gridClasses["columnHeader--last"]})`]:
		{
			backgroundColor: palette.yellow[50],
		},
	[`& .${gridClasses.columnHeader}.${gridClasses["columnHeader--pinnedLeft"]}`]: {
		backgroundColor: palette.yellow[50],
	},
	[`& .${gridClasses["cell--pinnedRight"]}`]: {
		backgroundColor: "inherit",
	},
	[`& .${gridClasses["cell--pinnedLeft"]}`]: {
		backgroundColor: "inherit",
	},
	[`& .${gridClasses.row}.danger:hover`]: {
		background: palette.red[50],
	},
	[`& .${gridClasses.row}.danger`]: {
		pointerEvents: "none",
		background: palette.red[50],
		opacity: 0.8,
	},
	[`& .${gridClasses.row}.${gridClasses["row--editing"]}`]: {
		boxShadow: "unset",
	},
	[`& .${gridClasses.row}.${gridClasses["row--editing"]}:has(.${inputClasses.error})`]: {
		color: palette.red[500],
	},
	[`& .${gridClasses.cell} > .${gridClasses.editInputCell}.${inputClasses.error}`]: {
		color: palette.red[500],
		borderColor: `${palette.red[500]} !important`,
	},
	[`& .${gridClasses.row}.${gridClasses["row--editing"]} > div`]: {
		backgroundColor: `${palette.yellow[50]} !important`,
	},
	[`& .${gridClasses.columnHeaders}`]: {
		borderBottom: `1px solid ${palette.grey[300]}`,
	},
	[`& .${gridClasses.columnHeader}`]: {
		borderColor: palette.grey[300],
		background: palette.grey[100],
		borderBottom: "unset !important",
	},
	[`& .${gridClasses.columnHeaders} .${gridClasses.filler}`]: {
		borderBottom: 0,
	},
	[`& .${gridClasses.row}`]: {
		background: palette.common.white,
	},
	[`& .${gridClasses.columnHeaderTitle}`]: {
		fontWeight: 600,
	},
	[`& .${gridClasses.cell}`]: {
		alignContent: "center",
		fontSize: theme.typography.fontSize,
	},
	[`& .${gridClasses.rowReorderCell}.${gridClasses["rowReorderCell--draggable"]}:hover`]: {
		cursor: "grab",
	},
	[`& .${gridClasses.cell} > *`]: {
		verticalAlign: "middle",
	},
	[`& .${gridClasses.overlayWrapper}:has(.no-results), & .${gridClasses.main}:not(:has(.${gridClasses.row})) .${gridClasses.overlayWrapper}:has(.loader)`]:
		{
			minHeight: "3rem",
			maxHeight: "3rem",
		},
	[`& .${gridClasses.overlayWrapperInner}:has(.loader)`]: {
		backgroundColor: alpha(palette.grey[500], 0),
		animationName: "loading",
		animationDuration: "2s",
		animationIterationCount: "infinite",
		animationTimingFunction: "linear",
	},
	[`& .${gridClasses.toolbar}`]: {
		borderTopWidth: "1px",
		borderBottom: 0,
		borderColor: palette.grey[300],
		padding: theme.spacing(1),
	},
})) as typeof DataGridPremium
